<div class="tasks-wrapper">
  <div class="tasks-filterbar">
    <cst-filter-bar
      #fb
      [filterGroup]="filterGroup"
      (filterChanged)="reload()"
    ></cst-filter-bar>
  </div>
  <div class="tasks-toolbar">
    <cst-toolbar>
      <ctrl-btn-create
        id="taskListCreateButton"
        (click)="OnTaskInsert()"
        [disabled]="isLoading"
        label="Create new task"
        i18n-label="Neue Aufgabe erstellen@@PlannungApiTasksCreateNewTask"
        type="basic"
      >
      </ctrl-btn-create>

      <ctrl-btn-delete
        id="taskListDeleteButton"
        [disabled]="!canDelete()"
        (click)="OnTasksDelete(undefined)"
        label="Delete"
        i18n-label="Button for deleting the selected tasks|@@BuTaskDelete"
        mat-tooltip="Tootltip of the task delete button|@@BuTaskDeleteTooltip"
        type="basic"
      >
      </ctrl-btn-delete>

      <ctrl-btn
        id="taskListImportButton"
        [disabled]="isLoading"
        (click)="OnTaskImport()"
        content="Import tasks"
        i18n-content="Aufgaben importieren@@buImportTasks"
        icon="cloud_upload"
      ></ctrl-btn>

      <ctrl-btn
        id="taskListExportButton"
        [matMenuTriggerFor]="menu"
        content="Export Tasks"
        i18n-content="@@export"
        icon="cloud_download"
      ></ctrl-btn>

      <mat-menu #menu="matMenu">
        @for (item of exportMenuItems; track item) {
          <button
            mat-menu-item
            (click)="item.callback()"
            [disabled]="isLoading"
          >
            @if (item.iconType === 0) {
              <fa [name]="item.icon"></fa>
            }
            @if (item.iconType === 1) {
              <mat-icon>{{ item.icon }}</mat-icon>
            }
            <span>{{ item.label }}</span>
          </button>
        }
      </mat-menu>
    </cst-toolbar>
  </div>
  <div>
    <app-shimmer [isLoading]="isLoading" type="table"></app-shimmer>
  </div>
  <div class="tasks-list" [ngStyle]="{ display: isLoading ? 'none' : 'block' }">
    <app-list-view
      [dataSource]="cstDataSource"
      [selectionEnabled]="true"
      [columns]="columns"
      [idColumn]="'id'"
      [elevated]="false"
      [responsive]="true"
      (contextMenuOpen)="openContextMenu($event)"
      (rowClicked)="onRowClicked($event)"
      [disableRipple]="true"
    ></app-list-view>
  </div>
</div>

<app-material-context-menu #contextMenu></app-material-context-menu>

<ng-template #filterTemplateResources let-filter="filter" let-form="form">
  <ng-container [formGroup]="form">
    <frm-planung-resource-select
      [formControlName]="filter.key"
      [label]="filter.label"
      [multiselect]="true"
      [onlyUsers]="filter.key === 'claimByResourceIds'"
      [allowNone]="true"
    >
    </frm-planung-resource-select>
  </ng-container>
</ng-template>

<ng-template
  #filterTemplateFacilityNo
  let-filter="filter"
  let-form="form"
  let-control="control"
>
  <ng-container [formGroup]="form">
    <frm-anlage-facility-no-select
      [label]="filter.label"
      [formControlName]="filter.key"
      [multiselect]="true"
    />
  </ng-container>
</ng-template>

<ng-template
  #filterTemplateTaskStates
  let-filter="filter"
  let-form="form"
  let-control="control"
>
  <ng-container [formGroup]="form">
    <app-task-status-droplist
      [label]="filter.label"
      [formControlName]="filter.key"
      [isMultiselect]="true"
      [forFilter]="true"
    >
    </app-task-status-droplist>
  </ng-container>
</ng-template>

<ng-template #filterTemplateMisc let-filter="filter" let-form="form">
  <ng-container [formGroup]="form">
    @switch (filter.key) {
      @case ("appointmentArrangements") {
        <frm-appointment-arrangement-select
          [formControlName]="filter.key"
          [label]="filter.label"
          [isMultiselect]="true"
        ></frm-appointment-arrangement-select>
      }
      @case ("categories") {
        <frm-planung-task-category-select
          [formControlName]="filter.key"
          [label]="filter.label"
          [multiselect]="true"
          width="100%"
        ></frm-planung-task-category-select>
      }
    }
  </ng-container>
</ng-template>

<ng-template #notificationIcons let-value="value" let-element="element">
  <div class="notification-icons">
    <div>
      @if (value === appointmentArrangement.Required) {
        <mat-icon
          color="error"
          style="width: 30px; height: 30px"
          i18n-title="@@AppointmentArrangement_Required_Tooltip"
          title="Appointment must be made"
          >perm_phone_msg
        </mat-icon>
      }
      @if (value === appointmentArrangement.Scheduled) {
        <mat-icon
          color="primary"
          style="width: 30px; height: 30px"
          i18n-title="@@AppointmentArrangement_Scheduled_Tooltip"
          title="Appointment scheduled"
          >event
        </mat-icon>
      }
    </div>
    <div>
      @if (element.hasUnreadNotes) {
        <mat-icon
          style="opacity: 0.75"
          i18n-title="@@PlanungApi_Tasks_HasUnreadNotes"
          title="Task has unread notes"
          >note
        </mat-icon>
      }
    </div>
  </div>
</ng-template>

<ng-template #stateName let-value="value" let-element="element">
  <div class="state-name full-width">
    @if (element.stateMeta) {
      <span class="fa-stack">
        <i [class]="'fas fa-circle fa-stack-2x'"></i>
        <i
          [class]="element.stateMeta.symbol + ' fa-stack-1x'"
          [ngStyle]="{ color: element.stateMeta.color }"
        ></i>
      </span>
      <span> - </span>
      <span>{{ element.stateMeta.displayLabel }}</span>
    }
    @if (!element.stateMeta) {
      <span>{{ value }}</span>
    }
  </div>
</ng-template>

<ng-template #plannedFor let-element="element">
  <span>{{ element.dateRanges.todoDate | date: "dd.MM.yyyy" }}</span>
  @if (element.dateRanges.todoTime) {
    <span> - {{ element.dateRanges.todoTime | date: "HH:mm" }}</span>
  }
</ng-template>
